module.exports = __webpack_public_path__ + "img/xETH.238811fc.svg";